// extracted by mini-css-extract-plugin
module.exports = {"carousel-item":"styles_carousel-item__naeQt","image":"styles_image__G190X","title":"styles_title__rpaZC"};